import types from "./types";
import { Action } from "@ctra/utils";

/**
 * Flush the cache for a specific key
 * @param {string[]} keys
 * @returns {Action}
 */
const flush = (keys: string[]): Action => ({
  type: types.FLUSH,
  payload: { keys }
});

export default {
  flush
};
